import { render, staticRenderFns } from "./denominators.vue?vue&type=template&id=76cf3c1d&scoped=true"
import script from "./denominators.vue?vue&type=script&lang=js"
export * from "./denominators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf3c1d",
  null
  
)

export default component.exports